import { FormService as OvermapFormService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormService extends OvermapFormService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
